/** Single-request export limit; aligns with reporting-service table defaults. */
export const EXPORT_PAGE_LIMIT = 1000
